import { EmptyTableState } from '@/modules/common/components/EmptyTableState';
import { getDefaultMRTOptions } from '@/modules/common/lib/react-material-table';
import { IEmployee } from '@/types/employer';
import {
  MRT_TableOptions,
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { getListEmployeesTableColumns } from './ListEmployeesTable.columns';

type ListEmployeesTableProps = {
  tableOptions: Omit<MRT_TableOptions<IEmployee>, 'columns'>;
  onManageLearningBudgetFunds?: (employee: IEmployee) => void;
  onDeleteEmployee?: (employee: IEmployee) => void;
};

const defaultMRTOptions = getDefaultMRTOptions<IEmployee>();

export function ListEmployeesTable({
  tableOptions,
  onManageLearningBudgetFunds,
  onDeleteEmployee,
}: ListEmployeesTableProps) {
  const table = useMaterialReactTable<IEmployee>({
    ...defaultMRTOptions,
    columns: getListEmployeesTableColumns({
      onManageLearningBudgetFunds,
      onDeleteEmployee,
    }),
    muiTableHeadProps: {
      sx: {
        display: tableOptions.data.length ? undefined : 'none',
      },
    },
    enableRowSelection: () => false, //disable but show a checkbox
    renderEmptyRowsFallback: ({ table }) => {
      const { columnFilters, globalFilter } = table.getState();
      const hasFilters =
        globalFilter ||
        columnFilters.some(columnFilter =>
          Array.isArray(columnFilter.value)
            ? columnFilter.value.length
            : columnFilter.value,
        );

      return (
        <EmptyTableState
          hasFilters={hasFilters}
          emptyStateImage="/images/no-people.png"
          emptyStateTitle="No employees found"
          emptyStateMessage="Once you add an employee, they will be displayed here."
        />
      );
    },
    enablePagination: !!tableOptions?.rowCount,
    ...tableOptions,
  });

  return <MaterialReactTable table={table} />;
}
